import { useTranslation } from 'react-i18next';

/** spec-klantsimulatie-aanmeldingen: één melding voor een interne rol zonder gekozen klant. */
export function KiesEersteKlant() {
  const { t } = useTranslation();

  return (
    <section
      data-testid="intake-kies-klant"
      className="max-w-2xl rounded-[var(--radius-control)] border border-[var(--border)] bg-[var(--background)] p-6"
    >
      <p className="text-base text-[var(--foreground-muted)]">{t('intake.kiesEersteKlant')}</p>
    </section>
  );
}
